<template>
  <div class="orgProjectRequests">
    <v-expansion-panel style="box-shadow: none">
      <div xs12 style="font-size: 24px; font-weight: 700; text-align: left; width: 100%; margin-bottom: 30px">Projects requested by users in your organization</div>
      <v-expansion-panel-content v-for="(item, index) in requests" :key="index" style="border-top: none !important; margin-bottom: 20px">
        <div slot="header" class="primary">
          <v-layout row style="word-break: break-word">
            <div style="width: 100px; height: 70px; background-repeat: no-repeat;background-size: cover;" :style="'background-image: url(' + options.projects.find(project => { return Number(project.id) === Number(item.projectId) }).config.unsplashImageUrl + ')'"></div>
            <div class="secondary--text" style="margin-left: 15px; font-size: 18px; font-weight: 700; display: flex; flex-direction: column; justify-content: center;">
              <div>{{ options.projects.find(project => { return Number(project.id) === Number(item.projectId) }).name }}</div>
              <div style="font-weight: 500">{{organizationName(item)}}</div>
            </div>
            <v-spacer></v-spacer>
            <div class="secondary--text" style="margin-left: 15px; font-size: 18px; font-weight: 700; display: flex; flex-direction: column; justify-content: center;">
              <div style="font-weight: 500">Requested By:</div>
              <div>{{ userOrganization.users.find(user => { return Number(user.id) === Number(item.userId) }).firstName }} {{ userOrganization.users.find(user => { return Number(user.id) === Number(item.userId) }).lastName }}</div>
            </div>
            <v-spacer></v-spacer>
            <div class="actionButtons" style="margin-left: 15px; font-size: 18px; font-weight: 700; display: flex; align-items: center;">
              <v-btn @click="editProject(item)" color="secondary primary--text" :ripple="false" round style="height: 45px; font-size: 18px; width: 160px">Edit</v-btn>
              <v-btn @click.stop="acceptProject(item, index)" color="secondary primary--text" :ripple="false" round style="height: 45px; font-size: 18px; width: 160px" :loading="acceptLoading && loadingIndex === index">Accept</v-btn>
              <v-btn outline @click.stop="deleteProject(item, index)" color="secondary primary--text" :ripple="false" round style="height: 45px; font-size: 18px; width: 160px" :loading="deleteLoading && loadingIndex === index">Decline</v-btn>
            </div>
          </v-layout>
        </div>
        <v-card>
          <v-card-text>
            <div class="projectArrow secondary--text"><div class="projectArrowDown"></div></div>
            <div class="projectPanel primary mb-2" style="width: 100%; height: 500px" v-if="options.projects.length > 0">
              <ProjectPanel v-on:manage-users="manageUsers(item)" v-bind:options="{project: options.projects.find(project => { return Number(project.id) === Number(item.projectId) })}"></ProjectPanel>
            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-if="requests.length === 0" style="border-top: none !important; margin-bottom: 20px">
        <div slot="header" class="primary--text" style="font-size: 18px; font-weight: 300">You have 0 pending requests</div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<style>
  .orgProjectRequests .v-expansion-panel__header{
    padding: 0px 0px !important;
  }
  .orgProjectRequests .v-expansion-panel__header__icon{
    display: none;
  }
  .orgProjectRequests .v-expansion-panel__body .v-card__text{
    padding: 10px 0px
  }
  .orgProjectRequests .projectArrow{
    position: absolute;
    top: 10px;
    left: 45px;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 9
  }
  .orgProjectRequests .projectArrowDown{
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 15px solid white;
  }
  .orgProjectRequests .actionButtons .v-btn__content{
    font-size: 18px
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ProjectPanel from '../appElements/ProjectPanel.vue'
import axios from 'axios'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedProject: null,
      subscribeDialog: false,
      selectedPlanId: null,
      acceptLoading: false,
      deleteLoading: false,
      loadingIndex: -1
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      userOrganization: 'getUserOrganization'
    }),
    masterRoleId () {
      return this.$store.getters['getRoleByName']('MASTER_ROLE').id
    },
    adminRoleId () {
      return this.$store.getters['getRoleByName']('ADMIN_ROLE').id
    },
    viewerRoleId () {
      return this.$store.getters['getRoleByName']('VIEWER_ROLE').id
    },
    requests () {
      if (!this.userOrganization || !this.userOrganization.organizationProjects || !this.userOrganization.organizationUserProjects) {
        return 0
      }
      var reqs = []
      var temp = this.userOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (var i = 0; i < temp.length; i++) {
        for (var j = 0; j < this.userOrganization.organizationProjects.length; j++) {
          if (Number(temp[i].projectId) === Number(this.userOrganization.organizationProjects[j].projectId) && this.userOrganization.organizationProjects[j].type.toLowerCase() === 'diy' && !this.userOrganization.organizationProjects[j].status.toLowerCase().includes('active') && this.userOrganization.users.find(user => { return Number(user.id) === Number(temp[i].userId) }).active) {
            reqs.push(temp[i])
            break
          }
        }
      }
      return reqs
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    organizationName (sub) {
      if (this.options.projects.length > 0) {
        var project = this.options.projects.find(item => { return item.id === sub.projectId })
        var organization = project.organizations.find(item => { return item.id === project.createdByOrganizationId })
        return organization.name
      }
    },
    manageUsers (project) {
      this.selectedProject = project
      this.dialogType = 'users'
      this.subscribeDialog = true
    },
    editProject (project) {
      this.$router.push({path: '/diy', query: {project: project.projectId, display: 'edit'}})
    },
    acceptProject (sub, index) {
      this.acceptLoading = true
      this.loadingIndex = index
      var project = this.options.projects.find(item => { return item.id === sub.projectId })
      project.status = 'Pending External Approval'
      axios.all([this.$store.dispatch('updateProject', project)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.getOrganizationData()
        } else {
          this.loadingIndex = -1
          this.acceptLoading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loadingIndex = -1
        this.acceptLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.userOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
          this.acceptLoading = false
          this.loadingIndex = -1
          this.deleteLoading = false
        } else {
          this.loadingIndex = -1
          this.deleteLoading = false
          this.acceptLoading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loadingIndex = -1
        this.deleteLoading = false
        this.acceptLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteProject (sub, index) {
      this.deleteLoading = true
      this.loadingIndex = index
      axios.all([this.$store.dispatch('deleteProject', {projectId: sub.projectId})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.getOrganizationData()
        } else {
          this.loadingIndex = -1
          this.deleteLoading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loadingIndex = -1
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted: function () {},
  components: {
    ProjectPanel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/OrganizationProjectRequests.vue